<!--代理商tree-->
<template>
  <div class="search-item">
    <span v-if="isShowLabel" class="item-label">{{ $t('app.auto_241_f85bb3b7') }}</span>
    <span v-if="isHigh" class="item-label">{{ $t('app.auto_242_bcb964f8') }}</span>
    <span v-if="isLow" class="item-label">{{ $t('app.auto_241_f85bb3b7') }}</span>
    <el-popover popper-class="agent-popover" placement="bottom-start" height="300" ref="choseAgentPopover" trigger="click"
      @show="showAgentDepartmentPopover" @hide="hideAgentDepartmentPopover" :visible-arrow="false">
      <div class="c-popover-tab-pane scrollbar-wrapper">
        <el-row :gutter="19">
          <el-col :span="24">
            <el-input class="keyword-search" :placeholder="searchPlaceholderText" v-model="filterAgentTextClass" clearable>
            </el-input>
          </el-col>
<!--           <el-col :span="3">
            <el-button type="primary" @click="searchTreeData">{{ $t('app.search') }}</el-button>
          </el-col> -->
        </el-row>
        <vueEasyTree v-if="isShowTree" :data="agentTreeData" :props="defaultProps" height="200px" show-checkbox
          check-on-click-node node-key="value" ref="agentClassTree" :filter-node-method="filterAgentNode"
          :default-checked-keys="selectAgent" :auto-expand-parent="false" @check="treeCheck">
        </vueEasyTree>
      </div>
    </el-popover>
    <!-- <el-form :model="agentForm" :rules="rules" ref="agentForm" >
      <el-form-item prop="lstAgentId" label-width="120">
        <el-input
          class="selectClass"
          :placeholder="inputPlaceholder"
          readonly
          v-model="agentForm.lstAgentId"
          v-popover:choseAgentPopover
        >
          <span class="el-input__suffix" slot="suffix">
            <span class="el-input__suffix-inner">
              <i
                class="el-select__caret el-input__icon el-icon-arrow-up"
                :class="{ 'is-reverse': showAgentDropDown }"
              ></i>
            </span>
          </span>
        </el-input>
      </el-form-item>
    </el-form> -->
    <el-input :class="[showErrorTips ? 'selectClass error' : 'selectClass']" :placeholder="inputPlaceholderText" readonly
      v-model="agentForm.lstAgentId" v-popover:choseAgentPopover>
      <span class="el-input__suffix" slot="suffix">
        <span class="el-input__suffix-inner">
          <i class="el-select__caret el-input__icon el-icon-arrow-down" :class="{ 'is-reverse': showAgentDropDown }"></i>
        </span>
      </span>
    </el-input>
    <p v-if="showErrorTips || showError" class="error-tips">{{ $t('app.auto_244_9d956674') }}</p>
  </div>
</template>

<script>
import { getDeptTreeInfo } from "@/api/basicApi";
import { CRM_CAMPUS_TREE } from "@/util/keys";
import vueEasyTree from "@wchbrad/vue-easy-tree"
import "@wchbrad/vue-easy-tree/src/assets/index.scss"
const debounce = (function () {
  let timer = 0;
  return function (func, delay) {
    clearTimeout(timer);
    timer = setTimeout(func, delay);
  };
})();
export default {
  name: "CampusTree",
  data() {
    var checkAgentId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('agentProvider.pleaseSelectAgent')));
      } else {
        callback();
      }
    };
    return {
      defaultProps: {
        children: "children",
        label: function (data) {
          return data["title"];
        }
      },
      selectAgent: [],
      selectAgentStr: "",
      filterAgentTextClass: "",
      agentTreeData: [],
      isShowTree: true,
      showAgentDropDown: false,
      agentForm: {
        lstAgentId: ""
      },
      radios: [],
      rules: {
        lstAgentId: [{ validator: checkAgentId }]
      },
      showErrorTips: false
    };
  },
  props: {
    showError: {
      type: Boolean,
      default: false
    },
    isShowLabel: {
      type: Boolean,
      default: false
    },
    isHigh: {
      type: Boolean,
      default: false
    },
    isLow: {
      type: Boolean,
      default: false
    },
    inputPlaceholder: {
      type: String,
      default: ""
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    isSingleChoice: {
      type: Boolean,
      default: false
    }
  },
  components:{
		vueEasyTree,
	},
  computed: {
    inputPlaceholderText() {
      return this.inputPlaceholder || this.$t('app.selectAgentPlaceholder');
    },
    searchPlaceholderText() {
      return this.searchPlaceholder || this.$t('app.searchAgentPlaceholder');
    }
  },
  mounted() {
    this.getTreeData();
  },
  methods: {
    // 点击搜索
    searchTreeData() {
      let val = this.filterAgentTextClass;
      if (this.showAgentDropDown) {
        this.isShowTree = false;
        debounce(() => {
          this.isShowTree = true;
          this.$nextTick(() => {
            this.$refs.agentClassTree.filter(val);
          });
        }, 300);
        if (val != "") {
          this.$set(this.agentTreeData[0], "disabled", true);
        } else {
          this.isExpand = false;
          this.$set(this.agentTreeData[0], "disabled", false);
        }
      }
    },
    async getTreeData() {
      let CampusTree = JSON.parse(
        sessionStorage.getItem(CRM_CAMPUS_TREE) || "[]"
      );
      if (CampusTree <= 0) {
        CampusTree = await getDeptTreeInfo();
        CampusTree = CampusTree.code === 0 ? CampusTree.data : [];
        sessionStorage.setItem(CRM_CAMPUS_TREE, JSON.stringify(CampusTree));
      }
      const that = this;
      function traverse(val) {
        for (let item of val) {
          item.title = `${that.breakUpCode(item.value)}-${item.title}`;
          if (item.children) {
            traverse(item.children);
          }
        }
      }
      traverse(CampusTree);
      let tree = [
        {
          title: this.$t('app.auto_640_2494517e'),
          children: CampusTree,
          key: "whole10000",
          value:"whole10000",
        }
      ];
      this.agentTreeData = tree;
    },
    breakUpCode(val) {
      return val.split("_")[1];
    },
    showAgentDepartmentPopover() {
      this.showAgentDropDown = true;
    },
    // 代理商名称
    hideAgentDepartmentPopover() {
      this.selectAgent = [];
      this.agentForm.lstAgentId = "";
      this.showAgentDropDown = false;
      let selectArr = this.$refs.agentClassTree.getCheckedKeys();
      let selectNodeArr = this.$refs.agentClassTree.getCheckedNodes();
      let selectPeopleName = [];
      if (selectArr.length > 0) {
        let selectPeopleArr = selectArr;
        selectNodeArr.map(item => {
          if (item.key != "whole10000") {
            selectPeopleName.push(item["title"]);
          }
        });
        let newSelectPeopleArr = selectPeopleArr.filter(item => {
          if (item) {
            return item;
          }
        });
        let selectAgentStr = selectPeopleName.join(",");
        this.selectAgent = newSelectPeopleArr;
        this.agentForm.lstAgentId = selectAgentStr;
      } else {
        this.selectAgent = [];
        this.agentForm.lstAgentId = "";
      }
      let lastArr = [];
      this.selectAgent = this.selectAgent.map((item, index) => {
        if (item && item.split("_")[1] - 0 > 0) {
          lastArr.push(item.split("_")[1] - 0);
        }
      });
      // this.$refs['agentForm'].clearValidate();
      this.showErrorTips = false;
      this.$emit("selectedAgentDepartment", lastArr);
    },
    filterAgentNode(value, data) {
      if (!value) {
        return true;
      }
	  return data.title.indexOf(value) !== -1;
      /* console.log(data,'data')
      let trueValue = data.value?.toString();
      if (data.value?.indexOf("_") > -1) {
        trueValue = data.value?.split("_")[1];
      }
      return (
        data.title?.toString().indexOf(value) !== -1 ||
        trueValue?.indexOf(value) !== -1
      ); */
    },
    clearSearch() {
      this.agentForm.lstAgentId = "";
      this.selectAgent = [];
      this.filterAgentTextClass = "";
      this.showErrorTips = false;
      this.$refs.agentClassTree.setCheckedKeys([]);
      let length = this.$refs.agentClassTree.$children.length;
      for (let i = 0; i < length; i++) {
        if (this.$refs.agentClassTree.$children[i].node) {
          this.$refs.agentClassTree.$children[i].node.parent.childNodes[i].expanded = false;
        }
      }
      // this.$refs['agentForm'].resetFields();
      // this.$refs['agentForm'].clearValidate();
    },
    treeCheck(node, list) {
      console.log(node, list);
      if (this.isSingleChoice) {
        //单选实现
        let checkedVal = [node.value];
        if (node.children && node.children.length) {
          checkedVal = [];
        }
        this.$refs.agentClassTree.setCheckedKeys(checkedVal);
      }
    },
    handleBucketClick(row) {
      console.log(row);
      this.radios = [];
      this.radios.push(row.key);
      console.log(this.radios);
    },
    //保证必选！
    checkForm() {
      // let formResult = false;
      // this.$refs['agentForm'].validate((valid) => {
      //   if (valid) {
      //     formResult = true;
      //   } else {
      //     formResult = false;
      //   }
      // });
      if (this.agentForm.lstAgentId) {
        this.showErrorTips = false;
      } else {
        this.showErrorTips = true;
      }
      return this.agentForm.lstAgentId != "" ? true : false;
    }
  },
  watch:{
	filterAgentTextClass(val) {
      this.$refs.agentClassTree.filter(val);
    },
  }
};
</script>

<style lang="scss">
.search-item {
  position: relative;
  display: flex;
  margin-bottom: 25px;
  width: 100%;

  .item-label {
    display: inline-block;
    width: 38%;
    text-align: right;
    margin-top: 10px;

    // padding-right: 12px;
    &:before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .selectClass {
    margin-left: 10px;

    // width: 403px;
    &.error {
      border-color: #f56c6c;
    }
  }
}

.keyword-search {
  margin-bottom: 10px;
  width:100%;
  .el-input__validateIcon{
	display:none !important;
}
}

.agent-popover {
  width: 556px;
}

.error-tips {
  position: absolute;
  top: 43px;
  left: 120px;
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}
</style>
